import React from "react";
import VStack from "../../../ui_atoms/VStack";
import { newMissionState } from "../../../atoms/core";
import { RecoilRoot } from "recoil";
import CreateMissionJobTitle from "../../../screens/create-mission/CreateMissionJobTitle";
import { FIND_ACTIVITY_TYPE } from "../../../graphql/core";
import { MockedProvider } from "@apollo/client/testing";
import { MockedAuthManager } from "../../../contexts/AuthManager";
import { ClientStatus, Gender, KycStatus, ProfileType } from "../../../__generated__/graphql";
import type { Meta, StoryObj } from "@storybook/react";
import { buildActivityType } from "../../factories";
import CreateMissionManager from "../../../contexts/CreateMissionManager";
import { MockedProfileSwitcherManager } from "../../../contexts/ProfileSwitcherManager";

function StoryComponent() {
    const mocks = [
        {
            request: {
                query: FIND_ACTIVITY_TYPE,
            },
            variableMatcher: () => true,
            newData: () => ({
                data: {
                    findActivityType: {
                        pageInfo: {
                            totalElements: 1,
                            hasNextPage: false,
                            hasPreviousPage: false,
                            startCursor: "fake-start-cursor",
                            endCursor: "fake-end-cursor",
                        },
                        elements: [
                            buildActivityType(),
                            {
                                id: "activity-01",
                                title: "The only one activity",
                            },
                        ],
                    },
                },
            }),
        },
    ];

    return (
        <RecoilRoot
            initializeState={(snap) => {
                snap.set(newMissionState, {
                    id: "fake-id",
                    currentContract: { contractEffectiveAsset: { id: "007" } },
                    workerInfo: {
                        gender: Gender.Female,
                    },
                });
            }}
        >
            <MockedProvider mocks={mocks}>
                <MockedAuthManager
                    user={{
                        id: "1",
                        gender: Gender.Female,
                        kycStatus: {
                            status: KycStatus.Accepted,
                            reason: null,
                            veriffUrl: "",
                        },
                        clientProfiles: [
                            {
                                id: "cp-1",
                                clientRelationshipCount: 0,
                                client: {
                                    id: "c-2",
                                    name: "Client name",
                                    status: ClientStatus.Accepted,
                                },
                            },
                        ],
                        clientInfos: [],
                        workerProfile: {
                            id: "wp-1",
                            relationshipCount: 0,
                            lppRegistrations: [],
                        },
                    }}
                    setAppExpoPushToken={() => {}}
                >
                    <MockedProfileSwitcherManager profileType={ProfileType.Client}>
                        <VStack
                            gap={1}
                            style={{ alignItems: "stretch", alignSelf: "stretch", flex: 1 }}
                        >
                            <CreateMissionManager>
                                <CreateMissionJobTitle />
                            </CreateMissionManager>
                        </VStack>
                    </MockedProfileSwitcherManager>
                </MockedAuthManager>
            </MockedProvider>
        </RecoilRoot>
    );
}

const meta = {
    title: "CreateMission/Job title",
    component: StoryComponent,
    argTypes: {},
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
